import { Grid } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  sendPatchRequest,
  allowedOperations,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";

const _ref = {
  uuid: "",
  code: "",
  name: "",
};

const SubjectEdit = () => {
  const { uuid } = getParams();
  var [subject, setSubject] = useState(_ref);
  const { canCreate } = allowedOperations();

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });
  useEffect(() => {
    sendGetRequest(
      `subjects?uuid=${uuid}`,
      (loading) => setStatus({ ...{ loading: loading } }),
      (data) => setSubject({ ...data })
    );
    return () => setSubject(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  const createUpdate = () => {
    if (!uuid) {
      delete subject.uuid;
      sendPostRequest(
        "subjects",
        subject,
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    } else {
      subject.uuid = uuid;
      sendPatchRequest(
        `subjects/${uuid}`,
        subject,
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    }
  };

  const onValueChange = (value, tag) =>
    setSubject({ ...subject, [tag]: value });

  return (
    <EditPage
      title={uuid ? `Edit Subject` : "Add Subject"}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now") : null}
      onSave={() => createUpdate()}
      validated={subject.code && subject.name && !status.loading}
      onBack={() =>
        navigate(`${AppRoutes.contents}/${AppRoutes.subjects}`, true)
      }
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setSubject({ ..._ref });
          navigate(`${AppRoutes.contents}/${AppRoutes.subjects}`, true);
        }
      }}
    >
      <Grid item md={4} xs={12}>
        <EasyTextEdit
          label="Subject short code"
          placeholder="Subject short code"
          type="text"
          id="code"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={subject.code}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <EasyTextEdit
          placeholder="Subject name"
          label="Subject name"
          type="text"
          id="name"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={subject.name}
          onChange={onValueChange}
        />
      </Grid>
    </EditPage>
  );
};

export default SubjectEdit;
